import yoigoNegocios1 from './yoigoNegocios1';

export default {
    yoigoNegocios1,
};